import React from 'react'
import { Link } from "react-router-dom";


const HomeFaq = () => {
    return (
        <>

            <section className="content-inner" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)', backgroundPosition: 'right bottom', backgroundRepeat: 'no-repeat' }}>
                <div className="container">
                    <div className="row content-wrapper style-5">
                        <div className="col-xxl-7 col-xl-6 col-lg-5 m-b30 align-self-center">
                            <div className="content-info">
                                <div className="section-head style-1 m-b30">
                                    <h2 className="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'none' }}>अक्सर पूछे जाने वाले सवाल</h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.4s', animationName: 'none' }}> ओमकार मल्टीस्पेशलिटी हॉस्पिटल में सभी मेडिकल सुविधाएँ एक ही छत के नीचे उपलब्ध हैं। यह 60 बिस्तरों वाला टर्शियरी केयर हॉस्पिटल है, जहाँ कई सुपर-स्पेशलिटी सेवाएँ दी जाती हैं। यह हॉस्पिटल आरंग में एक एकड़ की शानदार ज़मीन पर स्थित है। यहाँ मिलने वाली अलग-अलग सेवाओं में शामिल हैं:</p>
                                </div>
                                <div className="accordion dz-accordion style-1" id="accordionExample">
                                    <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.5s', animationName: 'none' }}>
                                        <h2 className="accordion-header">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                ओंकार मल्टीस्पेशलिटी हॉस्पिटल कौन-सी सेवाएँ देता है?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <p>सेवाओं का दायरा:- 24x7 इमरजेंसी सेवा</p>
                                                <p>24x7 फार्मेसी</p>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-5 col-xl-6 col-lg-7 m-b30">
                            <div className="content-media skrollable skrollable-before" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)" style={{ transform: 'translateY(50px)' }}>
                                <div className="dz-media">
                                    <img src="./assets/img/Frequently Asked Questions.webp" alt />
                                </div>
                                <div className="item1">
                                    <div className="info-widget style-5">
                                        <div className="widget-media text-primary">
                                            <i className="feather icon-phone-call dz-ring-effect" />
                                        </div>
                                        <div className="widget-content">
                                            <h6 className="title">Contact us</h6>
                                            <a href="tel:+91 9165155945" className="text-secondary">+91 9165155945</a>
                                        </div>
                                    </div>
                                    <Link to="/contact-us" className="btn btn-lg btn-icon btn-primary btn-shadow">
                                        <span className="w-100">Appointment</span> <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default HomeFaq